<template>
    <div class="navbar__subitem">
        <span class="navbar__link" @click="emitToggleEvent">
            <en-flag
                v-if="menuItem.getTitle == 'Internationalisering'"
            ></en-flag>
            {{ menuItem.getTitle }}</span
        >

        <ul class="navbar__items collapse-item" :style="computedStyle">
            <li>
                <a
                    v-for="subItem in menuItem.subMenuItems"
                    :key="subItem.id"
                    :href="subItem.url"
                    class="navbar__link"
                    :class="{ 'is-active': subItem.isActive }"
                    >{{ subItem.getTitle }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import { EventBus } from '@/js/helpers/eventbus';
import CollapseMixin from '@/js/mixins/collapse-mixin';
import enFlag from '@/components/nav/en-flag';

export default {
    components: {
        enFlag
    },
    mixins: [CollapseMixin],
    props: {
        menuItem: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    data() {
        return {
            isActive: false
        };
    },

    computed: {
        subItemIsActive() {
            return this.menuItem.subMenuItems.find(
                item => item.isActive === true
            );
        }
    },

    created() {
        this.isActive = this.subItemIsActive;
    },

    mounted() {
        EventBus.$on('toggle-sub-item', this.toggleSubMenu);
    },
    beforeDestroy() {
        EventBus.$off('toggle-sub-item', this.toggleSubMenu);
    },

    methods: {
        emitToggleEvent() {
            EventBus.$emit('toggle-sub-item', this.menuItem.id);
        },

        toggleSubMenu(id) {
            if (this.menuItem.id === id) {
                this.isActive = !this.isActive;
            } else {
                this.isActive = false;
            }
        }
    }
};
</script>

<style lang="scss">
.en-flag {
    margin-right: 0.5rem;
    width: 26px;
}
</style>
